/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import ImageUploadButton from '@/shared/components/ImageUploadButton/ImageUploadButton'
import Loader from '@/shared/components/Loader/Loader'
import styles from '@/features/menu-management/DataExtraction/DataExtraction.module.scss'
import IMAGE_SLOTS_KEYS from '@/shared/store/imageSlots.model'
import { useImageSlots } from '@/shared/store/useImageSlots'
import { HTTPInstanceFastApi } from '@/lib/http/http-instance-fastapi'
import { ErrorModel } from '@/shared/api/BaseAPI.model'
import { useSnackbar } from '@/shared/components/Snackbar/SnackbarProvider'

function DataExtraction() {
  const { t } = useTranslation()
  const { showSnackbar } = useSnackbar()

  const restaurantId = localStorage.getItem('restaurantId')
  const dataExtractionImageSlot = useImageSlots(
    s => s.slots[IMAGE_SLOTS_KEYS.DATA_EXTRACTION_SAMPLE_IMAGE]
  )
  const clearImageSlot = useImageSlots(s => s.clear)
  const dataExtractionImage = (file: File) => {
    const formData = new FormData()
    formData.append('image', file)
    return HTTPInstanceFastApi.post(
      `/api/restaurants/${restaurantId}/get-menu-items`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(response => response.data)
  }

  const { mutateAsync: dataExtractionImageMutation, isPending } = useMutation<
    any,
    ErrorModel,
    File
  >({
    mutationFn: (file: File) => dataExtractionImage(file),
    onSuccess: data => {
      console.log('Data extraction successful', data)
      showSnackbar(t('DATA_EXTRACTION.SUCCESS_MESSAGE'), 'success')
      clearImageSlot(IMAGE_SLOTS_KEYS.DATA_EXTRACTION_SAMPLE_IMAGE)
    },
    onError: () => {
      console.log('Data extraction failed')
      showSnackbar(t('DATA_EXTRACTION.ERROR_MESSAGE'), 'error')
    }
  })

  useEffect(() => {
    const blob = dataExtractionImageSlot?.croppedBlob
    if (!blob) return

    const croppedImage = new File([blob], 'croppedImage')
    dataExtractionImageMutation(croppedImage)
  }, [dataExtractionImageMutation, dataExtractionImageSlot?.croppedBlob])

  return (
    <div id="tour-data-extraction" className={styles.dataExtrationWrapper}>
      <ImageUploadButton
        imageShape="rectangle"
        slotId={IMAGE_SLOTS_KEYS.DATA_EXTRACTION_SAMPLE_IMAGE}
        label={t('DATA_EXTRACTION.IMAGE')}
        imageUrl={
          dataExtractionImageSlot?.croppedUrl ??
          dataExtractionImageSlot?.originalUrl ??
          ''
        }
        imageSize={{ width: 376, height: 608 }}
        stencilSize={{ width: 200, height: 432 }}
      />
      <p className={`${styles.dataExtractionDescription} body-medium`}>
        {t('DATA_EXTRACTION.DESCRIPTION')}
      </p>
      {isPending && (
        <div className={styles.loaderOverlay}>
          <Loader size="large" />
        </div>
      )}
    </div>
  )
}

export default DataExtraction
